import "./hero.styles.scss";

export const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__canvas">
        <div className="hero__blob hero__blob--1"></div>
        <div className="hero__blob hero__blob--2"></div>
        <div className="hero__blob hero__blob--3"></div>
        <div className="hero__grain"></div>
      </div>

      <div className="hero__container">
        <div className="hero__main">
          <h1 className="hero__title">
            <span className="hero__title-line hero__title-line--1">just a</span>
            <span className="hero__title-line hero__title-line--2">
              <em className="hero__italic">very</em>
              <span className="hero__highlight">passionate</span>
            </span>
            <span className="hero__title-line hero__title-line--3">
              software engineer
            </span>
          </h1>

          <div className="hero__footer">
            <p className="hero__description">
              in constant pursuit of
              <span className="hero__accent"> learning</span> and
              <span className="hero__accent"> contributing</span>
            </p>

            <div className="hero__actions">
              <a href="#featured" className="hero__link hero__link--primary">
                <span>projects</span>
                <span>
                  ↓
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="hero__corner hero__corner--br">
          <span>scroll</span>
        </div>
      </div>
    </section>
  );
};
